import React, {Suspense, useState} from 'react'
import ClientSuspense from '@components/ClientSuspense'
import NoSSR from '@components/NoSSR'
import SpinnerLoading from '@components/V3/loadingIndicators/Spinner'
import dynamic from 'next/dynamic'

import ReferralProgram from '../../components/ReferralProgram'

import {ContactModalContext} from './components/ContactModalContext'
import useOrder from './hooks/useOrder.main'
import ContactModal from './sections/ContactModal'
import {MainSkeleton} from './sections/Main'
import {OrderSkeleton} from './sections/Order'
import Other from './sections/Other'
import {StoreSkeleton} from './sections/Store'

const Order = dynamic(() => import('./sections/Order'), {loading: OrderSkeleton})
const Store = dynamic(() => import('./sections/Store'), {loading: StoreSkeleton})
const Main = dynamic(() => import('./sections/Main'), {loading: MainSkeleton})
const Driver = dynamic(() => import('./sections/Driver'))
const Review = dynamic(() => import('./sections/Review'))
const Reorder = dynamic(() => import('./sections/Reorder'))

export const ContentSkeleton = () => (
  <div className="md:px-6 lg:px-12 md:py-6 flex flex-col lg:gap-8 overflow-y-auto">
    <MainSkeleton />
    <StoreSkeleton />
    <OrderSkeleton />
  </div>
)

function WithContactModal({children}) {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  return (
    <>
      <NoSSR>
        <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
      </NoSSR>
      <ContactModalContext.Provider
        value={{isOpen: isContactModalOpen, setOpen: setIsContactModalOpen}}>
        {children}
      </ContactModalContext.Provider>
    </>
  )
}

function ContentInner() {
  const {order, loading} = useOrder()

  if (loading) {
    return <ContentSkeleton />
  }

  if (!order) {
    return <SpinnerLoading />
  }

  return (
    <div className="md:px-6 lg:px-12 md:py-6 flex flex-col lg:gap-8 overflow-y-auto">
      <WithContactModal>
        <Main />
        <Driver />
        <Other />
        <Store />
        <Review />
        <Order />
        <Reorder />
        <Suspense fallback={null}>
          <ReferralProgram />
        </Suspense>
      </WithContactModal>
    </div>
  )
}

export default function Content() {
  return (
    <ClientSuspense fallback={<ContentSkeleton />}>
      <ContentInner />
    </ClientSuspense>
  )
}
